import { Component, OnInit } from "@angular/core";
import { IDatatableConfig } from "../../../../auth/models/datatable";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { Router } from "@angular/router";
import { locale as jobPositionsIt } from "../../i18n/jobPositionsIt";
import { JobPositionsService } from "../../job-positions.service";
import { IJobCategory } from "app/auth/models/jobs";

@Component({
  selector: "app-job-categories-list",
  templateUrl: "./job-categories-list.component.html",
  styleUrls: ["./job-categories-list.component.scss"],
})
export class JobCategoriesListComponent implements OnInit {
  public config: IDatatableConfig;
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public contentHeader: IContentHeader;
  public jobCategory: IJobCategory;
  public jobCategoriesList: IJobCategory[] = [];
  public filteredJobCategoriesList: IJobCategory[] = [];
  public showModalError: boolean = false;

  constructor(
    public _modalService: NgbModal,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
    public _jobPositionsService: JobPositionsService,
  ) {
    this.contentHeader = {
      headerTitle: jobPositionsIt.data.MENU.JOB_POSITIONS_CATEGORIES,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: jobPositionsIt.data.MENU.JOB_POSITIONS_CATEGORIES,
            isLink: false,
          },
        ],
      },
    };
    this.config = {
      searchable: true,
      exportable: true,
      selectLimitItems: true,
      headerHeight: 30,
      rowHeight: 50,
      footerHeight: 60,
      scrollbarH: true,
    };
  }
  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_categories_job_positions_list")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this.loadJobCategories();
  }

  async loadJobCategories() {
    this.jobCategoriesList = await this._jobPositionsService.getListJobCategories();
    this.filterList();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  filterList() {
    let items: IJobCategory[] = this.jobCategoriesList;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = this.jobCategoriesList.filter((item: IJobCategory) => item.name.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()));
    }

    this.filteredJobCategoriesList = items;
  }

  public modalOpen(whichModal, jobCategory: IJobCategory) {
    this.showModalError = false;
    this.jobCategory = {
      name: null,
      description: null,
    };
    if (!!jobCategory) {
      this.jobCategory = {
        id: jobCategory.id,
        name: jobCategory.name,
        description: jobCategory.description,
      };
    }
    this._modalService.open(whichModal, {
      size: "sm",
      centered: true,
    });
  }

  isError(): boolean {
    if (!this.jobCategory.name || this.jobCategory.name.trim() === "" || this.jobCategory.name.length < 1) {
      this.showModalError = true;
      return true;
    }
  }

  async delete(currentItem: { name: string; id?: number }) {
    if (!this._authenticationService.hasCapability("delete_job_positions_category")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentItem.name;

    await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
      if (result.value) {
        await this._jobPositionsService
          .deleteJobCategory(currentItem.id)
          .then(async () => {
            await this._utilService.showPopupItemDeleted().then(async () => {
              await this.loadJobCategories();
            });
          })
          .catch(() => this._utilService.showSWALError({ text: "ERROR_JOB_CATEGORY_REMOVE" }));
      } else if (result.isDismissed) {
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    });
  }

  async add() {
    if (!this._authenticationService.hasCapability("create_job_positions_category")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    const data: IJobCategory = {
      name: this.jobCategory.name.trim(),
      description: this.jobCategory.description,
    };

    this._utilService.showLoading();
    await this._jobPositionsService
      .createJobCategory(data)
      .then(() => {
        this.loadJobCategories();
        this._modalService.dismissAll();
        this._utilService.hideLoading();
        this.filterList();
        this._utilService.showSWALSuccess({ text: "SUCCESS_JOB_CATEGORY_INSERT" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_JOB_CATEGORY_INSERT" });
      });
  }

  async edit() {
    if (!this._authenticationService.hasCapability("edit_job_positions_category")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    const data: IJobCategory = {
      name: this.jobCategory.name.trim(),
      description: this.jobCategory.description,
    };

    this._utilService.showLoading();
    await this._jobPositionsService
      .updateJobCategory(this.jobCategory.id, data)
      .then(() => {
        this._utilService.hideLoading();
        this.loadJobCategories();
        this.filterList();
        this._modalService.dismissAll();
        this._utilService.showSWALSuccess({ text: "SUCCESS_JOB_CATEGORY_EDIT" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_JOB_CATEGORY_EDIT" });
      });
  }
}
